(function () {
  function initSplitSlider(root) {
    if (root.dataset.splitReady === 'true') return;
    const track = root.querySelector('.split-arrive__grid');
    if (!track) return;

    root.dataset.splitReady = 'true';
    const prev = root.querySelector('.split-arrive__nav--prev');
    const next = root.querySelector('.split-arrive__nav--next');
    const progress = root.parentElement && root.parentElement.querySelector('[data-split-progress]');
    const bar = progress ? progress.querySelector('.split-arrive__progress-bar') : null;

    const step = function () {
      const item = track.querySelector('.split-arrive__item');
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return (item ? item.getBoundingClientRect().width : track.clientWidth / 2) + gap;
    };

    const sync = function () {
      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      const canScroll = maxScroll > 2;

      if (prev) {
        prev.disabled = track.scrollLeft <= 2;
        prev.setAttribute('aria-hidden', canScroll ? 'false' : 'true');
      }
      if (next) {
        next.disabled = track.scrollLeft >= maxScroll - 2;
        next.setAttribute('aria-hidden', canScroll ? 'false' : 'true');
      }

      if (progress) {
        progress.classList.toggle('is-idle', !canScroll);
      }

      if (!bar || !canScroll) return;

      const thumb = Math.min(90, Math.max(18, (track.clientWidth / track.scrollWidth) * 100));
      const left = (track.scrollLeft / maxScroll) * (100 - thumb);
      bar.style.width = thumb + '%';
      bar.style.marginLeft = left + '%';
    };

    const go = function (direction) {
      track.scrollBy({ left: direction * step(), behavior: 'smooth' });
    };

    if (prev) prev.addEventListener('click', function (event) {
      event.preventDefault();
      go(-1);
    });
    if (next) next.addEventListener('click', function (event) {
      event.preventDefault();
      go(1);
    });

    track.addEventListener('scroll', sync, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(sync).observe(track);
    }
    window.addEventListener('load', sync);
    sync();
  }

  function initAll() {
    document.querySelectorAll('[data-split-slider]').forEach(initSplitSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-split-slider]').forEach(initSplitSlider);
  });
})();
